import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import WitAIThumbDesktop from "../../assets/img/home/witbookingAI_Desktop.png";
import WitAIThumbMobile from "../../assets/img/home_imgs_mobile/WitbookingAI_Mobile.png";

export default function Videos() {
  const intl = useIntl();
  const [isAIVideoPlaying, setIsAIVideoPlaying] = useState(false);

  const loyaltyVideoUrl = intl.locale === "es-ES"
    ? "https://www.youtube.com/embed/vMWLgMOGASM?vq=hd1080&hd=1"
    : "https://www.youtube.com/embed/goichPGXdLE?vq=hd1080&hd=1";

  const messages = defineMessages({
    titleSEO: {
      id: "page.videos.titleSEO",
      description: "Video library - Witbooking booking engine",
      defaultMessage: "Videoteca - Motor de reservas Witbooking",
    },
    descriptionSEO: {
      id: "page.videos.descriptionSEO",
      description: "Discover all the features of the Witbooking booking engine through our video library",
      defaultMessage: "Descubre todas las funcionalidades del motor de reservas Witbooking a través de nuestra videoteca",
    },
    keywordSEO: {
      id: "page.videos.keywordSEO",
      description: "videos, booking engine, witbooking, tutorials, demos",
      defaultMessage: "videos, motor de reservas, witbooking, tutoriales, demos, videoteca",
    },
    breadcrumb: {
      id: "page.videos.breadcrumb",
      description: "page videos breadcrumb",
      defaultMessage: "Videoteca",
    },
    title: {
      id: "page.videos.pageTitle",
      description: "page videos title",
      defaultMessage: "Videoteca Witbooking: Todo sobre tu motor de reservas",
    },
    subtitle: {
      id: "page.videos.pageSubtitle",
      description: "page videos subtitle",
      defaultMessage: "A través de estos vídeos resumen, descubrirás el ecosistema que nos hace únicos. La hiper-personalización de Witbooker+, que garantiza una estética que seduce y convierte. La eficacia de la Estancia Partida, nuestra solución para que nunca vuelvas a perder una reserva por falta de disponibilidad y Witbooking AI, diseñada para personalizar totalmente la experiencia del huésped.",
    },
    aiTitle: {
      id: "page.videos.aiTitle",
      description: "Witbooking AI section title",
      defaultMessage: "Witbooking AI",
    },
    aiDescription: {
      id: "page.videos.aiDescription",
      description: "Witbooking AI description",
      defaultMessage: "Witbooking AI convierte la experiencia de reserva en un proceso dinámico y ultra-personalizado. Nuestra tecnología detecta en tiempo real el perfil del viajero (parejas, familias, business o grupos) y el contexto del viaje (temporada, festividades o eventos) para adaptar los contenidos y la estructura del motor.",
    },
    featuresAITitle: {
      id: "page.videos.featuresAITitle",
      description: "AI Features section title",
      defaultMessage: "Funcionalidades AI",
    },
    featuresAIDescription: {
      id: "page.videos.featuresAIDescription",
      description: "AI Features description",
      defaultMessage: "Integra los contenidos del hotel en asistentes de IA como ChatGPT o Gemini para responder en tiempo real sobre precios y disponibilidad. El motor personaliza la experiencia del huésped, permite optimizar resultados con tests A/B y gestionar promociones, traducciones y un concierge por WhatsApp que acompaña antes y durante la estancia, proponiendo upgrades, extras y actividades.",
    },
    customTitle: {
      id: "page.videos.customTitle",
      description: "Hypercustomization section title",
      defaultMessage: "Hipercustomización",
    },
    customDescription: {
      id: "page.videos.customDescription",
      description: "Hypercustomization description",
      defaultMessage: "Construye y personaliza tu propio motor de reservas. Elige entre las diferentes versiones del motor y aplica el branding de tu imagen corporativa: colores, tipografías y estilos (rectilíneo, redondeado, con fondo oscuro...)",
    },
    loyaltyTitle: {
      id: "page.videos.loyaltyTitle",
      description: "Loyalty system section title",
      defaultMessage: "Sistema de fidelización",
    },
    loyaltyDescription: {
      id: "page.videos.loyaltyDescription",
      description: "Loyalty system description",
      defaultMessage: "Ofrece a tus clientes recurrentes ventajas por reservar directo: descuentos, extras gratuitos o métodos de pago especiales. Este módulo gestiona tanto particulares, empresas como agencias de viaje. Área privada que se puede integrar en la página web para que el cliente pueda ver y gestionar sus reservas, recuperación de carrito y envío de precios del club a metabuscadores.",
    },
    splitStayTitle: {
      id: "page.videos.splitStayTitle",
      description: "Split stay section title",
      defaultMessage: "Estancia partida",
    },
    splitStayDescription: {
      id: "page.videos.splitStayDescription",
      description: "Split stay description",
      defaultMessage: "En periodos de alta ocupación, no le digas que 'no a tus clientes. Sigue ofreciendo disponibilidad con estancias con un cambio de habitación.",
    },
    dynamicPackagesTitle: {
      id: "page.videos.dynamicPackagesTitle",
      description: "Dynamic packages section title",
      defaultMessage: "Paquetes dinámicos",
    },
    dynamicPackagesDescription: {
      id: "page.videos.dynamicPackagesDescription",
      description: "Dynamic packages description",
      defaultMessage: "Creación rápida y sin mapeos en el channel manager de los paquetes.",
    },
  });

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(messages.titleSEO)}</title>
        <meta
          name="description"
          content={intl.formatMessage(messages.descriptionSEO)}
        />
        <meta
          name="keywords"
          content={intl.formatMessage(messages.keywordSEO)}
        />
      </Helmet>

      <div className="page-videos">
        <div className="container">
          <div className="videos-header">
            <h1 className="videos-title">
              <FormattedMessage {...messages.title} />
            </h1>
            <p className="videos-subtitle">
              <FormattedMessage {...messages.subtitle} />
            </p>
          </div>

          <div className="videos-grid">
            {/* Witbooking AI — featured: spans 2 columns */}
            <div className="video-item video-item--featured">
              <div className="video-content">
                <div className="video-wrapper">
                  {!isAIVideoPlaying ? (
                    <button
                      className="video-thumbnail-wrapper"
                      onClick={() => setIsAIVideoPlaying(true)}
                      aria-label="Play Witbooking AI video"
                    >
                      <picture>
                        <source media="(max-width: 767px)" srcSet={WitAIThumbMobile} />
                        <img
                          src={WitAIThumbDesktop}
                          alt="Witbooking AI video preview"
                          className="video-thumbnail-img"
                        />
                      </picture>
                      <span className="video-thumbnail-play" aria-hidden="true">
                        <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="30" cy="30" r="30" fill="#DBE5FF" />
                          <polygon points="24,18 46,30 24,42" fill="#2E3862" />
                        </svg>
                      </span>
                    </button>
                  ) : (
                    <iframe
                      width="560"
                      height="315"
                      src="https://www.youtube.com/embed/gkd4gX5WLIk?start=6&vq=hd1080&hd=1&autoplay=1"
                      title="WitbookingAI"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  )}
                </div>
              </div>
              <div className="video-info">
                <h2 className="video-item-title">
                  <FormattedMessage {...messages.aiTitle} />
                </h2>
                <p className="video-item-description">
                  <FormattedMessage {...messages.aiDescription} />
                </p>
              </div>
            </div>

            {/* Hyper-custom */}
            <div className="video-item video-item--regular">
              <div className="video-content">
                <div className="video-wrapper">
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/EGIoAq3bwEY?vq=hd1080&hd=1"
                    title="Hyper-custom"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div className="video-info">
                <h2 className="video-item-title">
                  <FormattedMessage {...messages.customTitle} />
                </h2>
                <p className="video-item-description">
                  <FormattedMessage {...messages.customDescription} />
                </p>
              </div>
            </div>

            {/* Loyalty System */}
            <div className="video-item video-item--regular">
              <div className="video-content">
                <div className="video-wrapper">
                  <iframe
                    width="560"
                    height="315"
                    src={loyaltyVideoUrl}
                    title="Sistema de fidelización"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div className="video-info">
                <h2 className="video-item-title">
                  <FormattedMessage {...messages.loyaltyTitle} />
                </h2>
                <p className="video-item-description">
                  <FormattedMessage {...messages.loyaltyDescription} />
                </p>
              </div>
            </div>

            {/* Split Stay */}
            <div className="video-item video-item--regular">
              <div className="video-content">
                <div className="video-wrapper">
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/QNUArrKy8v0?vq=hd1080&hd=1"
                    title="Estancia partida"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div className="video-info">
                <h2 className="video-item-title">
                  <FormattedMessage {...messages.splitStayTitle} />
                </h2>
                <p className="video-item-description">
                  <FormattedMessage {...messages.splitStayDescription} />
                </p>
              </div>
            </div>

            {/* Dynamic Packages */}
            <div className="video-item video-item--regular">
              <div className="video-content">
                <div className="video-wrapper">
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/4Uon-yxjjQo?vq=hd1080&hd=1"
                    title="Paquetes dinámicos"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div className="video-info">
                <h2 className="video-item-title">
                  <FormattedMessage {...messages.dynamicPackagesTitle} />
                </h2>
                <p className="video-item-description">
                  <FormattedMessage {...messages.dynamicPackagesDescription} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

